import React from "react";
import { SentivoLogo } from "./SentivoLogo";

export const Footer = () => {
  return (
    <footer
      className="bg-[#1A211D] text-[#FAF9F6] pt-20 pb-10 relative overflow-hidden"
      data-testid="site-footer"
    >
      <div
        aria-hidden
        className="absolute -top-32 -left-32 w-[400px] h-[400px] rounded-full opacity-10 blur-3xl"
        style={{ background: "radial-gradient(circle, #D16C4D 0%, transparent 70%)" }}
      />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-12 pb-16">
          <div className="lg:col-span-5">
            <SentivoLogo variant="light" />
            <p className="mt-6 max-w-sm text-[#D5DCD5]/80 leading-relaxed">
              AI that quietly cares — across elderly support, longevity, autism,
              cognitive health and beyond.
            </p>
          </div>

          <div className="lg:col-span-2">
            <FooterCol
              title="Company"
              links={[
                { l: "About", h: "#about" },
                { l: "Team", h: "#team" },
                { l: "Careers", h: "#contact" },
              ]}
            />
          </div>
          <div className="lg:col-span-2">
            <FooterCol
              title="Products"
              links={[
                { l: "ElderlyAssist", h: "#elderlyassist" },
                { l: "Focus Areas", h: "#focus" },
              ]}
            />
          </div>
          <div className="lg:col-span-3">
            <FooterCol
              title="Connect"
              links={[
                { l: "hello@sentivotech.ai", h: "mailto:hello@sentivotech.ai" },
                { l: "Press", h: "#contact" },
                { l: "Partnerships", h: "#contact" },
              ]}
            />
          </div>
        </div>

        {/* Huge wordmark */}
        <div className="border-t border-white/10 pt-10">
          <div className="font-serif text-[18vw] md:text-[14vw] leading-[0.9] tracking-tight text-white/[0.06] select-none whitespace-nowrap overflow-hidden">
            SentivoTech
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between gap-4 pt-8 text-xs text-[#D5DCD5]/60">
          <div>© {new Date().getFullYear()} SentivoTech. All rights reserved.</div>
          <div className="flex gap-6">
            <a href="#" className="hover:text-sentivo-accent transition" data-testid="footer-privacy">
              Privacy
            </a>
            <a href="#" className="hover:text-sentivo-accent transition" data-testid="footer-terms">
              Terms
            </a>
            <a href="#" className="hover:text-sentivo-accent transition" data-testid="footer-cookies">
              Cookies
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

const FooterCol = ({ title, links }) => (
  <div>
    <div className="text-xs uppercase tracking-[0.22em] text-[#E2A78E]/80 mb-5">{title}</div>
    <ul className="space-y-3">
      {links.map((l) => (
        <li key={l.l}>
          <a
            href={l.h}
            className="text-sm text-[#D5DCD5]/85 hover:text-white transition-colors underline-grow"
            data-testid={`footer-link-${l.l.toLowerCase().replace(/\s+/g, "-").replace(/@/g, "-at-").replace(/\./g, "-")}`}
          >
            {l.l}
          </a>
        </li>
      ))}
    </ul>
  </div>
);
